// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { EmpTypeTableColumn } from "../../../../Data/DataTables/EmploymentType";

// Types
import { ViewEmploymentType } from "../../../../Types/MasterData/EmploymentTypes";

// Services
import {
  VIEW_EMPTYPE_QUERY_KEY,
  employmentTypeService,
} from "../../../../Services/employmentTypesServices";

const EmploymentStatusTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_EMPTYPE_QUERY_KEY,
    queryFn: employmentTypeService.viewAllEmploymentType,
  });

  const filteredItems: ViewEmploymentType[] = usersResponse?.data.filter(
    (item: ViewEmploymentType) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={EmpTypeTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default EmploymentStatusTable;
